import { chakra } from '@chakra-ui/react';
import { ChevronDown } from 'lucide-react';
import { forwardRef } from 'react';
import { controlSize, selectTriggerActive, selectTriggerBase, type ControlSize } from './_shared';

const SelectEl = chakra('select', {
  base: {
    ...selectTriggerBase,
    appearance: 'none',
    pr: '9',
    _focusVisible: selectTriggerActive,
    '&[aria-invalid="true"]': { borderColor: 'status.danger' },
  },
});

export interface SelectProps
  extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size' | 'color'> {
  size?: ControlSize;
  invalid?: boolean;
}

/** Native, fully-accessible select styled to the system (custom chevron). */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { size = 'md', invalid, children, ...rest },
  ref,
) {
  return (
    <chakra.div position="relative" display="inline-flex" width="full" alignItems="center">
      <SelectEl ref={ref} aria-invalid={invalid || undefined} css={controlSize[size]} {...rest}>
        {children}
      </SelectEl>
      <chakra.span
        aria-hidden
        position="absolute"
        right="3"
        display="inline-flex"
        color="text.muted"
        pointerEvents="none"
      >
        <ChevronDown size={16} strokeWidth={2} />
      </chakra.span>
    </chakra.div>
  );
});
